<template>
  <v-dialog v-model="modalOpen" max-width="315px" class="DeletePromptModal">
    <v-card outlined>
      <v-card-title class="DeletePromptModal__title">
        <v-row>
          <v-col cols="auto" class="mr-auto">
            Delete Device
          </v-col>
          <v-col cols="auto">
            <v-btn icon @click="close">
              <v-icon small> mdi-close </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="DeletePromptModal__content">
        <p>
          Are you sure you want to delete this device?
        </p>
        <v-row>
          <v-col>
            <v-btn
              plain
              @click="onCancel"
              :disabled="removeDeviceLoading"
            >
              Cancel
            </v-btn>
            <v-btn
              color="error"
              @click="onDelete"
              :disabled="removeDeviceLoading"
              :loading="removeDeviceLoading"
            >
              Delete
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const { mapGetters: devicesGetters, mapActions: devicesActions } =
  createNamespacedHelpers("devices");

const { mapGetters: notificationsGetters } = createNamespacedHelpers('notifications');

export default {
  name: 'DeletePromptModal',
  props: {
    deviceId: {
      type: String,
      required: true
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...devicesGetters({
      removeDeviceLoading: 'REMOVE_DEVICE_LOADING',
    }),
    ...notificationsGetters({ hasError: 'HAS_ERROR' }),
    modalOpen: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    ...devicesActions(["deleteDevice"]),
    onDelete() {
      this.deleteDevice({ uid: this.deviceId });
    },
    onCancel() {
      this.close();
    },
    close() {
      this.modalOpen = false;
    }
  },
  watch: {
    removeDeviceLoading(value) {
      if (!value && !this.hasError) {
        this.close();
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import './delete-prompt-modal';
</style>
